import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "../Layout/Footer";

const Content = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white overflow-hidden">
      {/* TOP AREA (navbar + body) */}
      <div className="flex flex-1">
        {/* Desktop Sidebar */}
        <div className="hidden md:block">
          <Sidebar />
        </div>

        {/* Mobile Sidebar */}
        {menuOpen && (
          <div className="fixed inset-0 z-50 flex md:hidden">
            <div className="w-64 bg-white shadow-xl">
              <Sidebar mobile setMenuOpen={setMenuOpen} />
            </div>

            <div
              className="flex-1 bg-black/40"
              onClick={() => setMenuOpen(false)}
            ></div>
          </div>
        )}

        {/* MAIN COLUMN */}
        <div className="flex-1 flex flex-col">
          <Navbar setMenuOpen={setMenuOpen} />

          <main className="flex-1 overflow-auto bg-white">
            <Outlet />
          </main>
        </div>
      </div>

      {/* FOOTER (always bottom) */}
      <Footer />
    </div>
  );
};

export default Content;
